/* eslint-disable */
import React, { useEffect, useState } from "react";
import {
  Tooltip,
  Button,
  Modal,
  Form,
  Select,
  message,
  Input,
  Tabs,
} from "antd";
import "@/common.css";
import api from "@/utils/api";
import http from "@/utils/http";
import { CustomTable, CustomTableExtend } from "@/hocComponents";
import { approvalSummaryRouteDict } from "@/utils/dict";
import commonFn from "@/utils/commonFn";
import { checkApproveRouteDict } from "@/utils/dict";
import {
  CaretDownOutlined,
  OneToOneOutlined,
  SyncOutlined,
  ExclamationCircleOutlined,
  CheckOutlined,
  DeleteOutlined,
  MailOutlined,
} from "@ant-design/icons";
export default function ApprovalSummary() {
  const [tabsKey, setTabsKey] = useState('summary');
  const initTableHead = {
    role: null,
    module: null,
    firstName: null,
    dateTime: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);
  const [moduleList, setModuleList] = useState([]);
  const [totalDetail, setTotalDetail] = useState(0);
  const [selectedList, setSelectedList] = useState([]);
  const [openApproval, setOpenApproval] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [approvedOrRejected, setApprovedOrRejected] = useState("Approved");
  const [approvalForm] = Form.useForm();
  const [btnLoading, setBtnLoading] = useState(false);
  const [vendorPaymentIds, setVendorPaymentIds] = useState([]);
  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  const initColumns = [
    {
      title: "Module",
      dataIndex: "moduleType",
      titleType: "Select",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: moduleList,
      onChange: (value) => tableFilterFn(value, "module", "Select"),
    },
    {
      title: "Name",
      dataIndex: "firstName",
      titleType: "Input",
      width: 110,
      isSorter: true,
      sortterMultiple: 2,
      onChange: (e) => tableFilterFn(e, "firstName"),
    },
    {
      title: "Role",
      dataIndex: "role",
      titleType: "Input",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "role"),
    },
    {
      title: () => (
        <div>
          Transactions
          <div style={{ fontSize: 14, color: "#999" }}>
            ( Waiting For Approval/Total )
          </div>
        </div>
      ),
      dataIndex: "strTransactions",
      titleType: "",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      render: (text, record) => {
        const colorMatch = {
          1: "green",
          2: "red",
          3: "black",
        };
        return (
          <Tooltip title={record?.storeName}>
            <span
              style={{
                color: colorMatch[record.type] || "inherit",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => handleDetailClick(record)}
            >
              {text}
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: "Total Amount",
      dataIndex: "amount",
      titleType: "",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      isAmountFlag: true,
    },
    {
      title: "Level2 Approval",
      dataIndex: "lastPayPeriod",
      titleType: "",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
    },
  ];

  const handleDetailClick = (record) => {
    const { email, type, module, moduleType, storeName, batchGroup } = record;
    const params = { email, type, module, storeName, ...(tabsKey === 'detail' && { batchGroup }) };
    console.log("record,", record);
    const route =
      approvalSummaryRouteDict[module] || approvalSummaryRouteDict["default"];
    localStorage.setItem("currentMenu", `Approval Summary - ${moduleType}`);
    const url = `${window.location.origin}#${route}?${new URLSearchParams(
      params
    ).toString()}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [refreshKey1, setRefreshKey1] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      // count: pageSize || pagination.pageSize,
      viewType: tabsKey,
      count: 1000,
      ...tableHead,
    };
    const response = await http.get(api.getShowSummary, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const list = (response.data.list || []).map((item, index) => ({
      ...item,
      "#": (params.page - 1) * params.count + index + 1,
    }));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  // modal  相关
  const approveOrRejectFn = (approvedOrRejected) => {
    if (!selectedList.length) {
      message.warning("Please select at least one item");
      return;
    }
    //  console.log("当前勾选的数据:", selectedList);
    setOpenApproval(true);
    setApprovedOrRejected(approvedOrRejected);
    // 设置表单初始值，包括默认日期
    approvalForm.setFieldsValue({
      transactionCount: "1",
      isSend: 1,
    });
    getAllIds()
  };

  const getAllIds = async () => {
    setBtnLoading(true);
    const current = selectedList[0];
    const data = {
      email: current.email,
      type: current.module,
      batchGroup: selectedList[0]?.batchGroup
    };
    const response = await http.post(api.getAllRequestApprovalIds, data);
    if (response.code === "1") {
      setVendorPaymentIds(response.data.vendorPaymentIds);
    } else {
      message.error(`${approvedOrRejected} failed!`);
    }
    setBtnLoading(false);
  };

  const deleteInfoFn = () => {
    if (!selectedList.length) {
      message.warning("Please select at least one item");
      return;
    }
    getAllIds()
    setOpenDelete(true)
  }

  const deleteFn = async() => {
    setBtnLoading(true);
    const response = await http.post(api.approvaldDeleteAllRequest, {vendorPaymentIds });
    if (response.code === "1") {
      setOpenDelete(false)
      message.success("Delete Successfully.");
      setSelectedList([]);
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    } else {
      message.error(response?.msg || "Delete Failed");
    }
    setBtnLoading(false);
  }

  const handleSubmit = async () => {
    if (!selectedList.length) {
      message.warning("Please select at least one item");
      return;
    }
    setBtnLoading(true);
    const values = await approvalForm.validateFields();
    const current = selectedList[0];
    const data = {
      ...values,
      email: current.email,
      type: current.module,
      route:
        checkApproveRouteDict[current.moduleType] ||
        checkApproveRouteDict["default"],
        vendorPaymentIds,
    };
    const response = await http.post(api.getAllRequestApproval, data);

    if (response.code === "1") {
      message.success(`${approvedOrRejected} success!`);
      setOpenApproval(false);
      setSelectedList([]);
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
      // 重置表单
      approvalForm.resetFields();
    } else {
      message.error(`${approvedOrRejected} failed!`);
    }

    setBtnLoading(false);
  };

  const initColunmsFn = () => {
    // setTableHead(initTableHead);
    setColumns(initColumns);
  };

  const showSummaryDetailFn = async () => {
    const response = await http.get(api.showSummaryDetail);
    if (response?.code === "1") {
      setTotalDetail(response?.data);
    }
  };

  const getDictionaryFn = async (value) => {
    const response = await http.get(api.getDictionary, {
      params: { type: "util_payment", value },
    });
    setModuleList(response);
  };

  const downLoadFn = async () => {
    const blob = await http.get(api.exportSummaryCsv, {
      params: {},
      responseType: "blob",
    });
    return {
      blob,
      name: `PendingCheck`,
    };
  };

  useEffect(() => {
    getDictionaryFn("type");
  }, []);

  useEffect(() => {
    if (moduleList.length) {
      setColumns(initColumns);
    }
  }, [moduleList]);

  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 25, tableHead);
    showSummaryDetailFn();
  }, [refreshKey]);

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag("Download") && "download"]}
        downLoadFn={() => downLoadFn()}
      >
        <Tabs 
          defaultActiveKey={tabsKey} 
          items={[
            {key: 'summary', label: "Group By Module"},
            {key: 'detail', label: "Group By Batch"},
          ]}
          onChange={key => (setTabsKey(key), setTableHead(initTableHead),setRefreshKey(+new Date()), setRefreshKey1(+new Date()))}
        />
      </CustomTableExtend>

      <div className="topLeft" style={{marginBottom: 20}}>
        <Button className="btnNew" style={{ marginRight: 0 }}>
          Total Transactions: {totalDetail}
        </Button>
        <Button
          className="btnAgreed"
          style={{ marginRight: 0 }}
          onClick={() => approveOrRejectFn("Approved")}
        >
          <CheckOutlined />
          Send For Check Approval
          {selectedList.length > 0 && (
            <span >
              ({selectedList[0].pendingTransactions})
            </span>
          )}
        </Button>
        <Button
          className="btnRefused"
          style={{ marginRight: 0 }}
          onClick={() => deleteInfoFn()}
        >
          <DeleteOutlined />
          Delete
          {selectedList.length > 0 && (
            <span >
              ({selectedList[0].pendingTransactions})
            </span>
          )}
        </Button>
      </div>
      
      <CustomTable
        rowKey="summaryId"
        refreshKey={refreshKey1}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={false}
        handleTableChange={handleTableChange}
        tableScrollY="350px"
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "radio",
          selectedRowKeys: selectedList.map((item) => item.summaryId),

          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedList(selectedRows);
          },
          getCheckboxProps: (record) => ({
            disabled: record.type === 2, // type 为 2 的行禁止选择
          }),
        }}
      />

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            APPROVAL CONFIRMATION
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={openApproval}
        maskClosable={false}
        onCancel={() => {
          setOpenApproval(false);
          approvalForm.resetFields();
        }}
        onOk={handleSubmit}
        confirmLoading={btnLoading}
        width="30%"
      >
        <Form form={approvalForm} layout="vertical">
          <div style={{ marginBottom: "16px", fontSize: "20px" }}>
            Are you sure you want to request these checks to be approved?
          </div>

          <Form.Item
            name="transactionCount"
            label="How Many Transactions?"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                {
                  value: "1",
                  label: `${
                    approvedOrRejected === "Approved" ? "Approve" : "Reject"
                  } ${selectedList[0]?.pendingTransactions || 0} Check(s).`,
                },
              ]}
            />
          </Form.Item>

          <Form.Item name="remark" label="Note For Mike:" style={{ flex: 2 }}>
            <Input placeholder="" />
          </Form.Item>

          <Form.Item
            name="isSend"
            label="ls Email"
            style={{ flex: 1 }}
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Select option"
              options={[
                {
                  value: 1,
                  label: "Yes",
                },
              ]}
            />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            DELETE CONFIRMATION
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={openDelete}
        maskClosable={false}
        onCancel={() => {
          setOpenDelete(false);
        }}
        onOk={deleteFn}
        confirmLoading={btnLoading}
        width="30%"
      >
        <div style={{ marginBottom: "16px", fontSize: "20px" }}>
          {`Are you sure you want to request ${vendorPaymentIds?.length} checks to be delete?`}
        </div>
      </Modal>
    </div>
  );
}
